import React from 'react';

export const CustomForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Component Name
        </label>
        <input
          type="text"
          value={specificAttrs.componentName || ''}
          onChange={(e) => handleChange('componentName', e.target.value)}
          placeholder="MyCustomComponent"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Description
        </label>
        <textarea
          value={specificAttrs.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          rows={2}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px',
            fontFamily: 'inherit'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Props (JSON)
        </label>
        <textarea
          value={specificAttrs.props || ''}
          onChange={(e) => handleChange('props', e.target.value)}
          placeholder='{"prop1": "value1", "prop2": "value2"}'
          rows={4}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px',
            fontFamily: 'monospace',
            fontSize: '12px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Import Path
        </label>
        <input
          type="text"
          value={specificAttrs.importPath || ''}
          onChange={(e) => handleChange('importPath', e.target.value)}
          placeholder="./components/MyCustomComponent"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
    </div>
  );
};
